<template>
  <div class="course-question">
    <div class="pkg-search-box">
      <el-form class="pkg-content" id="selectForm" label-position="top" label-width="auto" :model="dataForm"
        @keyup.enter.native="getDataList()">
        <el-row class="search-box">
          <el-col :span="24">
            <el-row class="margb10" :gutter=20>
              <el-col :span="6">
                <div class="list-style-first" >
                  <p class="text">名称</p>
                  <!-- <el-input v-model="dataForm.courseName" placeholder="课程中文名称"></el-input> -->

                  <el-select v-model="dataForm.courseName"
                       remote
                       clearable
                       filterable
                       reserve-keyword
                       placeholder="名称"
                       :remote-method="querySearch">
                    <el-option v-for="(item,index) in resultCourseSlect"
                         :key="index"
                         :label="item.value"
                         :value="item.value">
              </el-option>
            </el-select>





                </div>
              </el-col>
              <el-col :span="6">
                <div class="list-style-first">
                  <p class="text">课程开发培训师</p>
                  <el-input v-model="dataForm.trainerName" placeholder="  课程开发培训师"></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="list-style-first">
                  <p class="text">创建人</p>
                  <el-input v-model="dataForm.courseCreatBy" :placeholder="$t('course.plsin')"></el-input>
                </div>
              </el-col>
              <!-- 按钮 -->
              <el-col :span="6" >
              <div class="all-btn-right">
                <div style="padding: 0px;
                           margin-left: 30px;
                           color: #252628FF;
                           font-size: 14px;
                            margin-top: 9px;" type="text" cursor: pointer class="show-or-hide-icon" v-bind:class="{
            'el-icon-arrow-up': moreList,
            'el-icon-arrow-down': !moreList,
          }" @click="moreList = !moreList">
                  &nbsp;<div style="margin:-22px 0 0 -58px">{{ moreList ? "收起" : "展开" }}</div>
                </div>
                <!-- 重置 -->
                <div class="button-style">
                  <el-button  @click="again">{{ $t("reset") }} </el-button>
                <!-- 查询 -->
                <el-button type="primary" v-if="checkSelect()" @click="getDataListMerge">{{ $t("course.query") }}
                </el-button>
                </div>
              </div>


              </el-col>
            </el-row>
            <el-row class="margb10" :gutter=20 v-show="moreList">








   <!-- 品牌 -->
   <el-col :span="6">
                <div class="list-style-first">
                  <p class="text">品牌</p>
                  <el-select v-model="brandQuery" filterable clearable placeholder="全部">
                    <el-option v-for="(item, index) in courseBrandArr" :key="index" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <!-- 业务团队 -->
              <el-col :span="6">
                <div class="list-style-first">
                  <p class="text">业务团队</p>
                  <el-select v-model="dataForm.teamType" filterable clearable placeholder="全部">
                    <el-option v-for="(item, index) in catalogArr" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <!-- 状态 -->
              <el-col :span="6">
                <div class="list-style-first">
                  <p class="text">状态</p>
                  <el-select v-model="dataForm.status" filterable placeholder="全部">
                    <el-option v-for="(item, index) in courseSta" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>

            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="pkg-content">
      <div class="table-style"  :style="{ 'min-width':800 + 'px' }">
        <el-table ref="multipleTable"   v-loading="dataListLoading" :data="dataList" tooltip-effect="light" :row-style="pointerStyle">
          <!--问题ID-->
          <el-table-column prop="courseQaId" :label="$t('course.coursequestion.courseQaId')" header-align="left"
            align="left" min-width="80" show-overflow-tooltip></el-table-column>
          <!--课程名称-->
          <el-table-column prop="courseName" :label="$t('course.coursequestion.courseName')" header-align="left"
            align="left" min-width="180" show-overflow-tooltip></el-table-column>
          <!--创建人-->
          <el-table-column prop="courseCreatBy" :label="$t('course.coursequestion.courseCreatBy')" header-align="left"
            align="left" min-width="180" show-overflow-tooltip :formatter="fmtUser"></el-table-column>
          <!--回复数-->
          <el-table-column prop="replyNum" :label="$t('course.coursequestion.replyNum')" header-align="left"
            align="left" min-width="80" show-overflow-tooltip></el-table-column>
          <!--提问时间-->
          <el-table-column min-width="180" prop="qaDate" :label="$t('course.coursequestion.qaDate')" header-align="left" align="left"
            show-overflow-tooltip :formatter="fmtDate">
          <template slot-scope="scope">
             {{formatDate(scope.row.qaDate)}}
          </template>
          </el-table-column>
          <!--问题内容 -->
          <el-table-column  prop="content" :label="$t('course.coursequestion.content')" header-align="left"
            show-overflow-tooltip align="left" min-width="120"></el-table-column>
          <!--图片-->
          <el-table-column prop="headImg" :label="$t('course.coursequestion.headImg')" header-align="center"
            align="center" min-width="100">
            <template slot-scope="scope">
              <div v-if="
                scope.row.qaContentList && scope.row.qaContentList.length > 0
              ">
                <span class="el-dropdown-link"  @click="showImage(scope.row)">查看</span>
                <!-- <viewer v-show="viewFlag" :images="imageList" ref="viewer">
                  <img v-for="(url, index) in imageList" style="width: 100%" :src="url" :key="index" />
                </viewer> -->
                 <div v-show="viewFlag" :images="imageList" ref="hevueImgPreview">
                  <img alt="" v-for="(url, index) in imageList" style="width: 100%" :src="url" :key="index" />
                </div>
              </div>
              <div v-else>–</div>
            </template>
          </el-table-column>
          <!--状态-->
          <el-table-column prop="status" :label="$t('course.coursequestion.status')" header-align="left" min-width="90"
            show-overflow-tooltip align="center">
            <!-- <template slot-scope="scope">
            <span>{{ statusFormat(scope.row) }}</span>
          </template> -->
            <template slot-scope="scope">
              <div style="display: flex; justify-content: left; align-items: center">
                <!--已屏蔽-->
                <span slot="reference" v-if="scope.row.status == 1" style="margin-right: 8px">
                  <em class="dotClass" style="background-color: #ff0c00"></em>
                </span>
                <!--已回复-->
                <span slot="reference" v-else-if="scope.row.status == 0 && scope.row.replyNum > 0"
                  style="margin-right: 8px">
                  <em class="dotClass" style="background-color: #07c23a"></em>
                </span>
                <!--未回复-->
                <span slot="reference" v-else style="margin-right: 8px">
                  <em class="dotClass" style="background-color: #ffac00"></em>
                </span>
                {{ statusFormat(scope.row) }}
              </div>
            </template>

          </el-table-column>
          <!--操作 -->
          <el-table-column :label="$t('offering.operation')" fixed="right"  header-align="center" align="left" width="138"   >


                 <span
                class="el-dropdown-link"
                v-if="checkReplyRole()"
                @click="dialogReplyOpen(scope.row)"
                >{{ $t("course.coursequestion.reply") }}</span
              >
              <div class="pkg-vertical-divider"></div>





              <!-- <template slot-scope="scope">
                     <el-dropdown trigger="click" placement="bottom">
                  <span class="el-dropdown-link">
                    {{ $t("course.coursequestion.operation") }}

                    <em class="el-icon-caret-bottom el-icon--right"></em>
                  </span>
                  <el-dropdown-menu slot="dropdown">

                    <el-dropdown-item v-if="checkReplyRole()" @click.native="dialogReplyOpen(scope.row)">{{
                    $t("course.coursequestion.reply") }}</el-dropdown-item>

                    <el-dropdown-item v-if="checkShieldRole()" @click.native="shieldPrompt(scope.row)">{{
                    $t("course.coursequestion.shield") }}</el-dropdown-item>

                    <el-dropdown-item v-if="checkDetailRole(scope.row)"
                      @click.native="dialogReplyDetailOpen(scope.row)">
                      {{ $t("course.coursequestion.detail") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template> -->








             <template slot-scope="scope">
            <div class="colum-right-style">
              <el-tooltip  content="回复" placement="bottom" effect="light" >
                <span v-if="checkReply()"  @click="dialogReplyOpen(scope.row)"><div><img src="@/assets/img/course/reply@2x.png" class="picIcon" alt="" /></div></span>

              </el-tooltip>

                <span v-if="!checkReply()"  ><div><img src="@/assets/img/course/reply_block@2x.png" class="picIcon" alt="" /></div></span>

            <span  style="width: 1px; height: 8px; color: #bebfc1">I</span>
             <el-tooltip  content="屏蔽" placement="bottom" effect="light" >
              <span v-if="checkShield()" @click="shieldPrompt(scope.row)"><div><img src="@/assets/img/course/shield@2x.png" class="picIcon" alt="" /></div></span>
             </el-tooltip>

              <span v-if="!checkShield()"><div><img src="@/assets/img/course/shield_block@2x.png" class="picIcon" alt="" /></div></span>

            <span style="width: 1px; height: 8px; color: #bebfc1">I</span>
          <div>
            <!-- When the number of replies is greater than 0, the details button is displayed -->
            <span v-show="scope.row.replyNum ==0||!checkDetail()"><div><img src="@/assets/img/course/detail_block@2x.png" class="picIcon" alt="" /></div></span>
            <el-tooltip content="明细"   placement="bottom" effect="light" >
            <span  v-show="scope.row.replyNum>0&&checkDetail()"><div @click="dialogReplyDetailOpen(scope.row)"><img src="@/assets/img/course/detail_colour@2x.png" class="picIcon" alt="" /></div></span>
           </el-tooltip>

          </div>
            </div>
          </template>
          </el-table-column>
        </el-table>


        <div class="table-bottom">
        <el-pagination :current-page="pageNo" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="total"
        layout="total,prev,pager,next,sizes,jumper" @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"></el-pagination>
      </div>
      </div>

      <reply v-if="dialogReplyVisible" @refresh="refresh" ref="reply" ></reply>
      <detail v-if="dialogReplyDetailVisible" ref="detail"></detail>
      <!--屏蔽-->
      <el-dialog :visible.sync="dialogShieldVisible" width="431px" :before-close="handleShieldClose">
        <div slot="title">
          <div class="dialog-modl-title-img">
            <img src="@/assets/img/course/Icon／Warning.png" alt="" />
          </div>
          <div class="dialog-modl-title">
            {{ $t("course.coursecomment.shieldConfirmPrompt") }}
          </div>
        </div>

        <div class="dialog-shield-info">
          {{ $t("course.coursecomment.shieldPrompt") }}
        </div>
        <div slot="footer" class="dialog-footer">
          <!-- 取消 -->
          <el-button    @click="dialogShieldVisible = false">{{
          this.$t("course.coursecomment.cancel")
          }}</el-button>
          <!-- 确定 -->
          <el-button  type="primary" @click="doShield">{{
          this.$t("course.coursecomment.confirm")
          }}</el-button>
        </div>
      </el-dialog>
    </div>



  </div>
</template>



<script>
import reply from "./reply";
import detail from "./detail";
import moment from "moment";

export default {
  components: {
    detail,
    reply,
  },
  data() {

    let _this = this;
    return {
      isReply:false,
      resultCourseSlect:[],
    courseSta:[


        {
          value: "0",
          label: "未回复",
        },
        {
          value: "1",
          label: "已回复",
        },
        {
          value: "2",
          label: "已屏蔽",
        },
      ],
      // 显示查看器
      viewFlag: false,
      imageList: [],
      moreList:false,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      getDataListURL: "/course/courseQa/listCourseQaByPage",
      shieldURL: "/course/courseQa/updateReplyStatus",
      brandURL: "/course/common/brand/listBrandByName",
      teamTypeURL: "/course/common/teamType/listTeamParentType",
      // 品牌类型
      // courseBrandArr: _this.enums["courseBrand"],
      courseBrandArr: [],
      // 课程状态
      newcoursestatus: _this.enums["courseStatus"],
      //业务团队分类
      //  catalogArr: _this.enums["catalogidList1"],
      catalogArr: [],

      teamTypeArr: _this.enums["teamType"],
      createtime: "", // TODO
      dialogReplyVisible: false,
      activatedIsNeed: true, // 此页面是否在激活（进入）时，调用查询数据列表接口？
      dataForm: {
        courseName: "", // 课程名称
        trainnerName: "", // 课程开发培训师
        courseCreatBy: "", // 创建人
        brandId: "", // 品牌
        courseType: "",
        teamType: "", // 创建人
        status: "",
      },
      dialogReplyDetailVisible: false,
      dataList: [],
      // 等待转圈
      dataListLoading: false,
      brandQuery: [],
      dialogShieldVisible: false,
      courseQaId : ""
    };
  },
  activated() {
    if (this.activatedIsNeed) {
      this.getDataList();
    }
  },
  created() {
    this.getListBrand();
    this.getListTeamType();
    this.getListTeamTypes();
  },
  methods: {
    pointerStyle(){
      return {
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "PingFang SC-Regular, ingFangSC-Regular, sans-serif",
        fontWeight: 400,
        color: "#252628"
      };
    },
    formatDate(date,format='YYYY-MM-DD HH:mm:ss'){
      return moment(date).format(format)
    },
    previewImg(url) {
      this.$hevueImgPreview(
        {url,
          clickMaskCLose :true
        })
    },
    // 回复完成后刷新列表
    refresh(data){
      if(data){
        console.log("===============")
        this.getDataList()
      }
    },
    // querySearch(queryString){

    //   this.$request
    //     .post(this.getDataListURL, {
    //       ps: {
    //         orderBy: [],
    //         pageNo: this.pageNo,
    //         pageSize: 20,
    //       },
    //       courseQaSearchVO:{
    //         courseName:queryString
    //       },
    //     })
    //     .then((res, total, code, data) => {
    //     console.log(res,"返回数据")
    //     this.resultCourseSlect=res.data
    //     //  this.resultCourseSlect=this.resultCourseSlect.map((item=>{
    //     //   item.value=item.courseName
    //     //   return item
    //     // }))
    //     .catch(() => {
    //       console.log(" this.$message");
    //     });


    //   },

  //

  querySearch(queryString){

    this.$request
        .post(this.getDataListURL, {
          ps: {
            orderBy: [],
            pageNo: 1,
            pageSize: 20,
          },
          courseQaSearchVO:{
            courseName:queryString
          }
        })
        .then((res, total, code, data) => {
          this.resultCourseSlect=res
          this.resultCourseSlect=this.resultCourseSlect.map((item)=>{
            item.value=item.courseName
            return  item
          })
        })
        .catch(() => {
          console.log(" this.$message");
        });




  },






    // 查询按钮权限
    checkSelect() {
      if (this.$hasPermission('learning:coursequestion:select')) {
        return true
      }
      return false
    },
    // 查看按钮权限
    checkCheck() {
      if (this.$hasPermission('learning:coursequestion:check')) {
        return true
      }
      return false
    },
    // 回复按钮权限
    checkReply() {
      if (this.$hasPermission('learning:coursequestion:reply')) {
        return true
      }
      return false
    },
    // 屏蔽按钮权限
    checkShield() {
      if (this.$hasPermission('learning:coursequestion:shield')) {
        return true
      }
      return false
    },
    // 明细按钮权限
    checkDetail() {
      if (this.$hasPermission('learning:coursequestion:detail')) {
        return true
      }
      return false
    },
    getListBrand() {
      this.dataListLoading = true;
      this.$request
        .post(this.brandURL)
        .then((res, total, code, data) => {
          this.courseBrandArr = data;


        })
        .catch(() => {
          console.log(" this.$message");
        });
    },
    getListTeamTypes() {
      this.dataListLoading = true;
      this.$request
        .post(this.teamTypeURL)
        .then((res, total, code, data) => {
          this.catalogArr = data;
        })
        .catch(() => {
          console.log(" this.$message");
        });
    },
    getListTeamType() {
      // this.dataListLoading = true;
      // this.$request
      //   .post(this.teamTypeURL)
      //   .then((res, total, code, data) => {
      //     this.catalogArr = data;
      //   })
      //   .catch(() => {
      //     console.log(" this.$message");
      //   });
      this.dataForm.status="";
      let courseQaSearchVO = JSON.parse(JSON.stringify(this.dataForm));
      this.dataListLoading = true;
      this.$request
        .post(this.getDataListURL, {
          ps: {
            orderBy: [],
            pageNo: this.pageNo,
            pageSize: this.pageSize,
          },
          courseQaSearchVO,
        })
        .then((res, total, code, data) => {
          this.dataListLoading = false;
          this.dataList = data.data;
          this.total = data.totalCount;
          this.dataForm.status=''
        })
        .catch(() => {
          console.log(" this.$message");
        });

    },
    //查询
    getDataList() {
      let courseQaSearchVO = JSON.parse(JSON.stringify(this.dataForm));
      this.dataListLoading = true;
      this.$request
        .post(this.getDataListURL, {
          ps: {
            orderBy: [],
            pageNo: this.pageNo,
            pageSize: this.pageSize,
          },
          courseQaSearchVO,
        })
        .then((res, total, code, data) => {
          this.dataListLoading = false;
          this.dataList = data.data;
          this.total = data.totalCount;
        })
        .catch(() => {
          console.log(" this.$message");
        });
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getDataList();
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.pageNo = val;
      this.getDataList();
    },
    // // 屏蔽
    // doShield(row) {
    //   this.$confirm(
    //     this.$t("course.coursequestion.shieldPrompt"),
    //     this.$t("course.coursequestion.deletePrompt"),
    //     {
    //       confirmButtonText: this.$t("confirm"),
    //       cancelButtonText: this.$t("cancel"),
    //       type: "warning",
    //     }
    //   )
    //     .then(() => {
    //       this.dataListLoading = true;
    //       this.isClose = false;
    //       this.$request
    //         .post(this.shieldURL, {
    //           qaId: row.courseQaId,
    //           replyStatus: 3,
    //         })
    //         .then((res, total, code, data) => {
    //           this.isClose = true;
    //           this.dataListLoading = false;

    //           this.$message({
    //             type: "success",
    //             message: this.$t("ourse.coursequestion.shieldSuccess"),
    //             duration: 5000,
    //           });
    //         })
    //         .catch(() => {
    //           this.dataListLoading = false;
    //           this.isClose = true;
    //           console.log(" this.$message");
    //         });
    //     })
    //     .catch(() => {});
    // },
    // 查询
    getDataListMerge() {
      this.pageNo = 1;
      if (this.brandQuery != null || this.brandQuery !== "") {
        this.dataForm.brandId = this.brandQuery + "";
      }
      if (this.createtime === null || this.createtime === "") {
        this.dataForm.createtime = null;
      }
      this.getDataList();
    },
    // 重置
    again() {
      this.dataList = [];
      this.brandQuery = "";
      this.createtime = "";
      (this.dataForm = {
        courseName: "", // 课程名称
        trainnerName: "", // 课程开发培训师
        courseCreatBy: "", // 创建人
        brandId: "", // 品牌
        courseType: "",
        teamType: "", // 创建人
        status: "",
      }),
        (this.dataListLoading = false);
      this.getDataListMerge();
    },
    //打开回复dialog
    dialogReplyOpen(row) {
      this.dialogReplyVisible = true;
      this.$nextTick(() => {
        this.$refs.reply.dialogReplyData.qaId = row.courseQaId;
        this.$refs.reply.dialogReplyData.courseName = row.courseName;
        this.$refs.reply.dialogReplyData.courseCreatBy = row.courseCreatBy;
        this.$refs.reply.dialogReplyData.courseCreatRealName =row.courseCreatRealName;
        this.$refs.reply.dialogReplyData.content = row.content;
        this.$refs.reply.continueFlag = false;
        this.$refs.reply.visible = true;
      });
    },
    //打开明细dialog
    dialogReplyDetailOpen(row) {
      this.dialogReplyDetailVisible = true;
      this.$nextTick(() => {
        this.$refs.detail.visible = true;
        this.$refs.detail.qaId = row.courseQaId;
        this.$refs.detail.getDetailDataList();
      });
    },
    // 查看图片
    showImage(data) {
      console.log(data,"data数据")
      this.imageList = [];
      data.qaContentList.forEach((file) => {
        this.imageList.push(file.content);
      });
      // this.$refs["viewer"].$viewer.show();
      // this.$refs["hevueImgPreview"].$hevueImgPreview();
      let urlList=[]
      data.qaContentList.map((item)=>{
        urlList.push(item.content)
      })
      this.$hevueImgPreview(
        {
          clickMaskCLose :true,
          multiple: true,
          imgList:urlList
        })
    },
    shieldPrompt(row) {
      this.dialogShieldVisible = true;
      this.courseQaId = row.courseQaId;
    },
    doShield() {
      this.dataListLoading = true;
      this.$request
        .post(this.shieldURL, {
          qaId: this.courseQaId,
          replyStatus: 3,
        })
        .then((res, total, code, data) => {
          this.dialogShieldVisible = false;
          this.dataListLoading = false;

          this.$message({
            type: "success",
            message: this.$t("course.coursequestion.shieldSuccess"),
            duration: 5000,
          });
          this.getDataListMerge();
        })
        .catch(() => {
          this.dataListLoading = false;
          this.dialogShieldVisible = false;
          console.log(" this.$message");
        });
    },
    handleShieldClose() {
      this.dialogShieldVisible = false;
    },
    // 屏蔽
    checkShieldRole() {
      if (this.$hasPermission("learning:coursequestion:shield")) {
        return true;
      }
      return false;
    },
    // 回复
    checkReplyRole() {
      if (this.$hasPermission("learning:coursequestion:reply")) {
        return true;
      }
      return false;
    },
    // 明细
    checkDetailRole(row) {
      if (row.replyNum <= 0) {
        return false;
      }
      if (this.$hasPermission("learning:coursequestion:detail")) {
        return true;
      }
      return false;
    },
    fmtUser(row, column, cellValue) {
      return row.courseCreatRealName + "(" + row.courseCreatBy + ")";
    },
    statusFormat(obj) {
      var statusDesc = "";
      if (obj.status == 1) {
        statusDesc = "已屏蔽";
      } else if (obj.status == 0 && obj.replyNum > 0) {
        statusDesc = "已回复";
      } else {
        statusDesc = "未回复";
      }
      return statusDesc;
    },
    fmtDate(row, column, cellValue) {
      cellValue = typeof cellValue == "number" ? cellValue : Number(cellValue);
      var time = new Date(cellValue);
      return `${time.getFullYear()}-${
        time.getMonth() + 1 >= 10
          ? time.getMonth() + 1
          : "0" + (time.getMonth() + 1)
      }-${time.getDate() >= 10 ? time.getDate() : "0" + time.getDate()} ${
        time.getHours() >= 10 ? time.getHours() : "0" + time.getHours()
      }:${
        time.getMinutes() >= 10 ? time.getMinutes() : "0" + time.getMinutes()
      }:${
        time.getSeconds() >= 10 ? time.getSeconds() : "0" + time.getSeconds()
      }`;
    },
  },


 }
</script>
<style lang="scss" scoped>
@import "../../../../css/pkg-styles.css";
@import "../../../../../assets/scss/modules/trainingCharge.scss";
.all-btn-right{
   display:flex;
   white-space:nowrap;
   margin-top: 38px;
   float: right;
}
/deep/ .el-table {
    tr th,
    tr td {
      border-right: none;
    }
  }

.el-dropdown-link{
color: #1C69D4;
}
/deep/.show-or-hide-icon{
  min-width:23px!important;
}
.course-question {
  height: 100%;
  width: 100%;
  .el-table th {
    border-right: none !important;
  }
  .pkg-search-box {
    width: 100%;
    height: 100%;
    background-color: white;
    padding: 0px 0 21px 0;
    .search-box{
      margin-top: -14px;
    }
  }

  .pkg-content {
    width: 100%;
    height: 100%;
    background-color: white;
    margin-top: 20px;
  }
}


.search-item {
  width: 94% !important;
  /*min-width: 290px;*/
}
.list-style-first {
  display: flex;
  white-space: nowrap;
  flex-direction: column;
  .text{
    display: flex;
    justify-content: flex-start;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
   color: #252628;
  }
}



.dotClass {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: block;
}
.colum-right-style{
  display: flex;
    flex-direction: row;
    column-gap: 8px;
    text-align: center;
    justify-content: center;
}

.el-pagination{
    display: flex;
    float: right;
    padding: 8px 3px 21px 0;
  .el-pagination__jump{
    margin-left: 1px!important;
  }
  .el-pager{
    display: flex;
    flex-direction: row;
    column-gap: 9px;
    .number.active{
      color: #ffffff!important;
      background:#1C69D4FF!important;
      border-radius: 2px!important;

    }
    .number{
    width: 30px;
    height: 29px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #DFE0E2;
    }
  }
  .btn-prev{
    height: 29px;
    background: #FFFFFF;
    border-radius: 1px;
    border: 1px solid #DFE0E2;
    margin-right: 10px;
    margin-left: 7px;
  }
  .btn-next{
    height: 29px;
    background: #FFFFFF;
    border-radius: 1px;
    border: 1px solid #DFE0E2;
    margin-right: 4px;
    margin-left: 10px;
  }

}

 .el-form-item__label {
  font-weight: 500;
  color: #000000;
}
</style>
<style lang="scss">
.course-question{
  ::-webkit-scrollbar {
    width: 7px;
    margin-top: 10px;
    height: 8px;
    background-color: #f5f5f5 !important;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
  }
}
</style>
 <style scoped>
.search-item .el-form-item__label {
  font-weight: 500;
  font-size: 50px;
  color: #771313;
}
</style>


<style lang="scss" scoped>
/deep/ .el-dialog__footer {
  padding: 0 !important;
}
/deep/ .el-dialog__body {
  padding: 30px 20px 10px
}
.el-form {
  .el-form-item {
     .el-form-item__label {
      * {
        font-size: 18px;
        color: blue;
        margin-left: 0px;
        width: auto;
      }
    }
  }
}

.dialog-modl-title-img {
  width: 80px;
  height: 0px;
  position: relative;
  top: 20px;
  left: 0px;
}

.dialog-modl-title {
  padding-top: 0px !important;
  width: 80px;
  height: 30px;
  position: relative;
  top: 23px;
  left: 30px;
  font-size: 16px;
  font-weight: 600;
  color: #252628;
}

.dialog-info {
  width: 230px;
  line-height: 25px;
  padding-left: 30px !important;
  align-content: left;
  word-break: break-all !important;
  color: rgb(8, 8, 8);
  font-size: 14px;
  font-weight: 400;
}

.dialog-shield-info {
  width: 260px;
  line-height: 25px;
  padding-left: 30px !important;
  align-content: left;
  word-break: break-all !important;
  color: rgb(8, 8, 8);
  font-size: 14px;
  font-weight: 400;
}

.dialog-footer {
  margin: 10px;
  padding-bottom: 20px !important;
  padding-top: 0px !important;
  align-content: right;
  // width: 800px;
}
.table-bottom{
  height: 57px;
  background-color: #FFFFFF;
}
::-webkit-scrollbar {
    width: 7px;
    margin-top: 10px;
    height: 8px;
    background-color: #f5f5f5 !important;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
  }
  .table-style{
    overflow-x: hidden;
  }
  .button-style{
    margin-top: 5px;
  }
  .el-input__inner {
      border-radius: 4px !important;
    }
    .el-table__fixed-right{
  // width: 100px!important;
    height: 100%!important;
}
.picIcon{
  cursor: pointer;
  width: 20px!important;
}
</style>

